







import {
    Component,
    Vue,
    Advisor,
    ComponentConfig,
    ComponentStyle,
    ComponentStyleDefinition,
    isRecommendationBundles,
    ProductRecommendation
} from "@zoovu/runner-browser-api";
import FilePDF from "../utils/file-pdf";
import PDFreactor from "../plugins/pdfreactor/PDFreactor.js";
import {PdfConfiguration, ColorsConfiguration} from "../configuration";

@Component({})
export default class PdfDownloadButtonView extends Vue {
    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @ComponentConfig(PdfConfiguration)
    pdfConfiguration: PdfConfiguration;

    @ComponentConfig(ColorsConfiguration)
    colorsConfiguration: ColorsConfiguration;

    isDownloading = false;

    get advisor(): Advisor {
        return this.$root.componentViewModel;
    }

    get isBundle(): boolean {
        return isRecommendationBundles(this.advisor.advice);
    }

    get isShown(): boolean {
        return this.pdfConfiguration && this.pdfConfiguration.enabled;
    }

    get cssWithVariables(): string {
        const pdfCss = this.pdfConfiguration && (this.isBundle ? this.pdfConfiguration.bundlePdfTemplates.css : this.pdfConfiguration.pdfTemplates.css);
        const rootStyles = `:root { --primary-color: ${this.colorsConfiguration.primaryColor}; --secondary-color: ${this.colorsConfiguration.secondaryColor};}`;
        return `${rootStyles}${pdfCss || ""}`;
    }

    renderPdfMarkup(): void {
        this.$root.$emit("toggle-pdf-markup", true);
    }

    removePdfMarkup(): void {
        this.$root.$emit("toggle-pdf-markup", false);
    }

    async onClickPdfDownload(): Promise<void> {
        if(this.isDownloading) return;

        try {
            this.isDownloading = true;
            this.renderPdfMarkup();

            const pdfDocument = await this.pdfHtmlTemplate();

            const pdfReactor = new PDFreactor("https://pdf.tiger.tools.zoovu.com/service/rest");
            const config = {
                addLinks: true,
                // Specify the input document
                document: pdfDocument,
                userStyleSheets: [
                    {
                        content: this.cssWithVariables
                    }
                ]
            }

            const result = await pdfReactor.convert(config);
            const pdfFile = new FilePDF.fromBase64(result.document);

            pdfFile.download(`${this.$t("message-filename-pdf-download")}.pdf`);
            this.advisor.publicTracker.sendPdfExportSetEvent({products: this.getProducts()});
        } catch (e) {
            throw new Error(e);
        } finally {
            this.removePdfMarkup();
            this.isDownloading = false;
        }
    }

    getProducts(): ReadonlyArray<ProductRecommendation> {
        const advice = this.advisor.advice;

        if(!advice || !advice.currentPage) {
            return [];
        }

        let products: ProductRecommendation[] = new Array<ProductRecommendation>();
        advice.currentPage.forEachProduct((product) => {
            products.push(product);
        });
        return products;
    }

    async pdfHtmlTemplate(withStyles: boolean = false): Promise<string> {
        await this.$nextTick();
        const htmlContent = this.$root.$refs && this.$root.$refs.pdfContent && (this.$root.$refs.pdfContent as HTMLElement).innerHTML;

        if (htmlContent) {
            return `<html><head><title></title>${withStyles ? `<style>${this.cssWithVariables}</style>` : ''}</head><body>${htmlContent}</body></html>`
        }
        return "";
    }
}
